import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import type { InvoiceReportJournalResponse } from 'ap-openapi';
import { useGetInvoiceReportJournalSuspense } from 'ap-openapi';
import { useMemo } from 'react';

type FetchInvoiceReportJournalEntriesResult = {
  data?: InvoiceReportJournalResponse;
  error?: {
    messages?: string[];
    code?: string;
  };
};

export const useInvoiceReportJournalEntries = (
  reportId: string
): FetchInvoiceReportJournalEntriesResult => {
  const { data, error } = useGetInvoiceReportJournalSuspense(reportId, {
    query: {
      queryKey: ['invoiceReportJournalEntries', reportId],
    },
  });

  if (error) {
    throw error;
  }

  const body = data?.data;
  const status = data?.status;
  const isSuccessStatus = isSuccess(status);

  return useMemo(() => {
    if (!isSuccessStatus) {
      return {
        error: {
          messages:
            typeof body === 'object' && isCommonError(body)
              ? body.messages
              : undefined,
          code: status?.toString(),
        },
      };
    }
    return {
      data: body,
    };
  }, [body, status, isSuccessStatus]);
};
